// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XYlTG","boxInfo":"styles_boxInfo__zoruF","title":"styles_title__tKGPU","smallInfo":"styles_smallInfo__JQXJa","rating":"styles_rating__ggKDb"};